import { useEffect, useState, useRef, useContext } from "react";
import { MdEmail, MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { Row, Col, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { RiBuildingLine } from "react-icons/ri";
import { MdLocalPhone } from "react-icons/md";
import { http } from "../auth";
import EfectivoImg from "../components/EfectivoImg";
import ServiciosPagar from "../components/ServiciosPagar";
import { bancos, telefonos, documento } from "../utils/bancos";
import { ThemeContext } from "../App";
import { useThemeManager } from "../Hooks/ThemeManager";

const Oficina = () => {
  const [sede, setSede] = useState([]);
  const [user, setUser] = useState({});
  const [selectedOption, setSelectedOption] = useState(18);
  const [loading, setLoading] = useState(true);
  const [mapLoading, setMapLoading] = useState(true);
  const { themeColors } = useThemeManager();

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  useEffect(() => {
    http
      .get(`/sedes-ver`)
      .then((response) => {
        setSede(response.data);
        setTimeout(() => setLoading(false), 500); 
      })
      .catch((error) => {
        console.error("Error al obtener los datos de las sedes:", error);
      });
  }, [selectedOption]);

  useEffect(() => {
    setMapLoading(true);
  }, [selectedOption]);

  return (
    <div>
      <div className="header-pago">
        <Link to="/pago" className="back">
          <div className="color-primary">
            <MdOutlineKeyboardArrowLeft className="btn-back" />
          </div>
          <div>
            <span>Volver</span>
          </div>
        </Link>
        <div className="titulo-efectivo">
          <RiBuildingLine className="icon-efectivo-p" />
          Pago en oficina
        </div>
      </div>
      <div className="containerPagos color-secondary">
        <div className="container-efectivo">
          <div className="pagosContainer-2">
            <span className="header-efectivo">Consulta la oficina más cercana a tu dirección</span>
            <Form.Group className="m-3 padding-efectivo">
              <Form.Select value={selectedOption} onChange={handleOptionChange}>
                {sede?.data?.map((item) => (
                  <option key={item?.id_sede} value={item?.id_sede}>
                    {item?.nombre}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <div className="bg-efectivo">
              {selectedOption && (
                <div className="header-efectivo">
                  {sede?.data?.map((item) => {
                    const [dias, ...horas] = item.horario[0].split(/(?<=\bViernes\b)/);
                    const [dias2, ...horas2] = item.horario[1].split(/(?<=\bSábado+\b)/);
                    if (item?.id_sede === parseInt(selectedOption)) {
                      return (
                        <div key={item?.id_sede} className="d-flex flex-column">
                          <span className="font-direccion">
                            {item?.direccion} {item?.zona_municipio?.valor}
                          </span>
                          <div className="mapaContenedor-efectivo mt-2 mb-2">
                            <div className="mapa" style={{ position: 'relative' }}>
                              <iframe
                                width="100%"
                                height="100%"
                                className="iframeMap"
                                style={{ border: 0 }}
                                allowFullScreen
                                referrerPolicy="no-referrer-when-downgrade"
                                onLoad={() => setMapLoading(false)}
                                src={`https://maps.google.com/maps?q=${item?.coordenadas}&z=14&t=m&output=embed`}
                              ></iframe>
                              {mapLoading && (
                                <div className="contenSpinner" style={{ position: 'absolute', inset: 0 }}>
                                  <div className="spinner blue"></div>
                                </div>
                              )}
                            </div>
                          </div>
                          <span className="title-efectivo">Horario de atención</span>
                          <div className="horario top">
                            <div>{dias.trim()}</div>
                            <div>{horas.join(" ").trim()}</div>
                          </div>
                          <div className="horario bottom">
                            {" "}
                            <div>{dias2.trim()}</div>
                            <div>{horas2.join(" ").trim()}</div>
                          </div>
                          <span className="title-efectivo">Datos de contacto</span>
                          <div className="bg-contacto">
                            <Row>
                              <Col xs={12} xxl={6}>
                                <span className="datos-contacto">Números teléfonicos</span>
                                <div className="info-contacto">
                                  <div className="bg-info-contacto">
                                    <div className="d-flex justify-content-between align-items-center">
                                      <span className="contacto-text">Master</span>
                                      <span className="telefono">
                                        {item?.telefonos} <MdLocalPhone className="icon-efectivo" />
                                      </span>
                                    </div>
                                    <div className="hr-efectivo" />
                                    <span className="extension mt-1">Extensiones</span>
                                    <div className="extensiones">
                                      {item?.extensiones?.map((extension, index) => {
                                        const [title, value] = extension.split(":");
                                        return (
                                          <div className="extension-item" key={index}>
                                            <span className="extension-title">{title.trim()}</span>
                                            <span className="extension-value">{value.trim()}</span>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </div>
                              </Col>
                              <Col xs={12}  xxl={6}>
                                <span className="datos-contacto mt-sm-0">Correos electrónicos</span>
                                <div className="info-contacto">
                                  {item?.email &&
                                    Object.entries(item.email).map(([key, value], index) => {
                                      const [title, email] = `${key}: ${value}`.split(": ");
                                      return (
                                        <div key={index} className="extension-email">
                                          <div className="email-title">
                                            <span>{title}</span>{" "}
                                            <MdEmail className="icon-efectivo" />
                                          </div>
                                          <div className="email-value">
                                            <span>{email}</span>{" "}
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              )}
            </div>
            <span className="nota">Los pagos en oficina no requieren ser reportados</span>
          </div>
         {/*  <span className="header-efectivo mt-5 mb-3">Agendar una promesa de pago</span>
          <div className="pagosContainer-2">
            <ServiciosPagar themeColors={themeColors} />
            <div className="tarifa-total">
              <span>Tarifa total</span>
              <span>
                <strong>1.405,33 Bs.</strong>
              </span>
            </div>
            <span className="label-persona">Selecciona a la persona que realizara el pago</span>
            <Form.Group className="padding-efectivo select-persona">
              <Form.Select>
                <option value="">Agregar nuevo pagador...</option>
              </Form.Select>
            </Form.Group>
            <div className="form-pagador">
              <Row>
                <Col xs={5} sm={2} lg={4} xxl={2}>
                  <Form.Group className="mb-3">
                    <Form.Label>Tipo doc.</Form.Label>
                    <Form.Select>
                      {documento.map((banco) => (
                        <option key={banco.value} value={banco.value}>
                          {banco.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={7} sm={10} lg={8}  xxl={10}>
                  <Form.Group className="mb-3">
                    <Form.Label>Doc. </Form.Label>
                    <Form.Control type="number" />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={5} sm={2} lg={4} xxl={2}>
                  <Form.Group className="mb-3">
                    <Form.Label>Prefijo</Form.Label>
                    <Form.Select>
                      {telefonos.map((banco) => (
                        <option key={banco.value} value={banco.value}>
                          {banco.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xs={7} sm={10} lg={8} xxl={10}>
                  <Form.Group className="mb-3">
                    <Form.Label>Número teléfonico</Form.Label>
                    <Form.Control type="number" />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                <Form.Group className="mb-3">
                    <Form.Label>Correo electrónico</Form.Label>
                    <Form.Control type="email" />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                <Form.Group className="mb-3">
                    <Form.Label>Fecha y hora para la visita del pago</Form.Label>
                    <Form.Control type="date" />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                <Form.Group className="mb-3">
                    <Form.Label>Fecha y hora para la visita del pago</Form.Label>
                    <Form.Control as="select" >
                      <option value="">oficina</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </div> */}
        </div>
        <div className="side-image">
          <EfectivoImg  theme={themeColors}/>
        </div>
      </div>
    </div>
  );
};

export default Oficina;
